export default [
    // members sidebar index route
    {
        path: '/requests',
        component: () => import(/* webpackChunkName: "residents-index" */ '@/views/requests/index.vue'),
        meta: {
            layout: 'dashboard'
        },
        children: [
            {
                path: '',
                name: 'requests.index',
                component: () => import(/* webpackChunkName: "residents-" */ '@/views/requests/index.vue'),
                meta: {
                    layout: 'dashboard'
                }
            }
        ]
    }
]
